import * as SearchPageLayout from 'components/DealerPage/styles';
import { GridIc, ListIc } from '@dsch/dd-icons';
import { Sort } from 'components/DealerPage/components/Sort/Sort';
import React from 'react';
import { Dealer } from 'domains/Dealer';
import styled from 'styled-components';
import {
  useDealerPageDispatch,
  useDealerPageState,
} from 'components/DealerPage/context/DealerPageContext';

interface DetailsAndTogglesProps {
  dealer: Dealer;
  totalAds: string;
  cdnUrl: string;
  domain: string;
}

export const ListTitle = styled.h2`
  flex: 1 1 auto;
  ${({ theme }) => theme.fontSize.M14};
  font-weight: normal;
  word-break: break-word;
`;

const DetailsAndToggles = ({ dealer, totalAds }: DetailsAndTogglesProps) => {
  const { sort, viewType } = useDealerPageState();
  const { setSort, setViewType } = useDealerPageDispatch();

  return (
    <SearchPageLayout.DetailsAndToggles>
      <SearchPageLayout.Details data-testid="h2-details-text">
        <span>
          <strong>{`${totalAds} ads`}</strong> from{' '}
          <strong>{`${dealer.name}`}</strong> in{' '}
          <strong>{`${dealer.region}`}</strong>
        </span>
      </SearchPageLayout.Details>
      <SearchPageLayout.Toggles>
        <SearchPageLayout.ViewTypeButtons>
          <SearchPageLayout.ViewTypeButton
            size="SMALL"
            active={viewType === 'list'}
            title="List View"
            onClick={() => setViewType('list')}
          >
            <ListIc />
          </SearchPageLayout.ViewTypeButton>
          <SearchPageLayout.ViewTypeButton
            size="SMALL"
            active={viewType === 'grid'}
            title="Grid View"
            onClick={() => setViewType('grid')}
          >
            <GridIc />
          </SearchPageLayout.ViewTypeButton>
        </SearchPageLayout.ViewTypeButtons>
        <div>
          <Sort selected={sort} onChange={setSort} />
        </div>
      </SearchPageLayout.Toggles>
    </SearchPageLayout.DetailsAndToggles>
  );
};

export { DetailsAndToggles };
